import React from "react";
import { Link } from "react-router-dom";

const Agree = ({
  setIsAgree,
  title = "",
}: {
  setIsAgree: React.Dispatch<React.SetStateAction<boolean>>;
  title?: string;
}) => {
  return (
    <div
      id="tutorial"
      style={{ backgroundImage: "url(/imgs/etc/bg.jpg)" }}
      className="fixed w-[100vw] h-[100vh] top-0 left-0 bg-cover text-white flex items-center justify-between px-28 z-50 bg-[#FF8F79]"
    >
      <div
        className="flex flex-col items-center justify-center w-full h-full mx-auto"
        style={{ maxWidth: "1200px" }}
      >
        <p className="mb-6 text-8xl bold">Welcome to inDJ!</p>
        <p className="text-3xl  leading-tight text-[#e1e1e1]">
          The AI provide musiclist by your Feelings.
        </p>
        <div
          className="mt-10 text-2xl border rounded-2xl"
          style={{
            backgroundColor: "rgba(0,0,0,0.7)",
            padding: "50px",
            backdropFilter: "blur(10px)",
          }}
        >
          {title && (
            <p className="text-3xl">
              2024년 시민·지역기업 중심 AI바우처 시민체감형 AI제품 구축 사업
              일환
            </p>
          )}
          <p style={{ marginTop: "20px", marginBottom: "20px" }}>
            개인정보의 수집 및 이용에 대한 동의
          </p>
          <p>가. 수집 및 이용 목적</p>
          <p
            className="text-gray-400"
            style={{ marginTop: "5px", marginBottom: "30px" }}
          >
            ㈜인디제이에서 실시하는 눈치AI for 멀티모달 솔루션 사용에 필요한
            사항(비전DB, 목소리DB, 감정분석 결과값 )에 대하여 감정인식 음악추천
            솔루션 사용에 있어서 개인정보를 수집하고 있습니다.
          </p>
          <p>나. 수집 및 이용 항목</p>
          <p
            className="text-gray-400"
            style={{ marginTop: "5px", marginBottom: "30px" }}
          >
            1) 수집항목 : 비전(얼굴이미지), 목소리(소리 녹음), 감정분석 DB 값
          </p>
          <p>다. 개인정보의 보유 및 이용 기간</p>
          <p
            className="text-gray-400"
            style={{ marginTop: "5px", marginBottom: "30px" }}
          >
            사용자의 개인정보 수집ㆍ이용에 관한 동의일로부터 1년동안 위
            이용목적을 위하여 보유 및 이용하게 됩니다.
          </p>
          <p>
            개인정보 수집 및 이용에 대한 동의를 하지 않으시면 서비스 이용이
            제한될 수 있습니다.
          </p>
        </div>
        <div
          className="flex w-full gap-4 mt-4"
          style={{ justifyContent: "flex-end" }}
        >
          <Link to="/">
            <button
              style={{
                backgroundColor: "rgba(0,0,0,0.7)",
                backdropFilter: "blur(10px)",
              }}
              className="w-56 py-3 text-gray-400 border rounded-xl"
            >
              동의하지 않음
            </button>
          </Link>
          <button
            style={{
              backgroundColor: "rgba(0,0,0,0.7)",
              backdropFilter: "blur(10px)",
            }}
            onClick={() => setIsAgree(true)}
            className="w-56 py-3 border rounded-xl"
          >
            동의함
          </button>
        </div>
      </div>
    </div>
  );
};

export default Agree;
